/* eslint-disable max-len */
import React,{useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
import CustomOverLay from '../Noroutes/Noroutes'
import { useLocation } from 'react-router-dom'
export default function Noroute() {
    // const location=useLocation()
    // const navigate=useNavigate()
    // useEffect(() => {
    //     setTimeout(() => {
    //         navigate('/')
    //     }, 3000);
    // }, [])
    
    return (<CustomOverLay Active text="Loading ARCM Provider/Monitor Web Application" classKey="fixed top-0 left-0 right-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center"/>)
}